import React from 'react';

import { ACCOUNT_PATHS } from '@/lib/accountPaths';
import {
  ACCOUNT_VAULT_CARDS,
  ACCOUNT_VAULT_EXPIRED,
} from '@/pages/account/accountFixture';
import { useAccountRecord } from '@/pages/account/AccountRecordContext';
import { accountCount } from '@/pages/account/accountModel';
import {
  AccountCard,
  CardColumn,
  Chip,
  NavLink,
  NotYetButton,
  Row,
  ScopeChip,
  StatusChip,
  TextAreaField,
} from '@/pages/account/primitives';
import { SettingsPageShell } from './SettingsPageShell';
import { SETTINGS_CARDS } from './settingsSearchIndex';

/**
 * AR-390 — Payments + CardVault.
 *
 * D-ACCT-38 (Jason 2026-09-18) — PARKED, exactly as Proposal Builder is: the
 * page renders by link so nothing breaks, and it is out of the column and out
 * of the settings search until the product returns.
 */
export const SettingsPayments: React.FC = () => {
  const { record } = useAccountRecord();
  const v = record.vault;

  return (
    <SettingsPageShell page="payments">
      <CardColumn>
        <AccountCard name={SETTINGS_CARDS.vaultKey.name} chip={<ScopeChip scope="personal" />}>
          <Row label="Personal encryption key" chip={<StatusChip status="Set" />} />
          <Row label="Key established" value={v.keySet} last />
          <div className="pt-2">
            <NotYetButton note="Rotating the key re-encrypts every card — Member Success walks it through with you">
              Manage key
            </NotYetButton>
          </div>
        </AccountCard>

        <AccountCard name={SETTINGS_CARDS.vaultStatus.name}>
          <Row
            label="Cards stored"
            value={accountCount(ACCOUNT_VAULT_CARDS, 'card', 'cards')}
            chip={
              ACCOUNT_VAULT_EXPIRED ? (
                <Chip tone="amber">
                  {accountCount(ACCOUNT_VAULT_EXPIRED, 'expired', 'expired')}
                </Chip>
              ) : undefined
            }
          />
          <Row
            label="Team access"
            value={record.teamset.vault}
            extra={<NavLink to={ACCOUNT_PATHS.team}>Managed under Team + Access →</NavLink>}
            last
          />
          <div className="pt-2">
            <NotYetButton note="Payments runs on WorldVia.pro until the CRM lands.">
              Manage stored cards →
            </NotYetButton>
          </div>
        </AccountCard>

        <AccountCard
          cardKey="vault"
          name={SETTINGS_CARDS.vaultComms.name}
          chip={<ScopeChip scope="personal" />}
          form={<TextAreaField path="vault.payEmail" label="Default payment email text" />}
        >
          <Row label="Default payment email text" value={v.payEmail} last />
        </AccountCard>
      </CardColumn>
    </SettingsPageShell>
  );
};

export default SettingsPayments;
